import React, { Component } from "react";

import colors from "../../colors";
// import menu from "../data/data";//menu
import Slider from "./Slider";
import ReactHtmlParser from "react-html-parser";
const home =
  '<ul> <li style="text-align: justify;">To characterize spatio-temporal variability of hydrological drought</li> </ul> <ul style="text-align: justify;"> <li>To provide hydrological drought indices based on geo-spatial data, hydrological model outputs and observational/field data.</li> </ul> <ul> <li style="text-align: justify;">To provide operational hydrological drought services.</li> </ul>';

export default class HDProjObjective extends Component {
  render() {
    return (
      <div
      className="cardeck_full"
     
    >
      <div className="carddeck_inner"
        style={{
        
          backgroundColor: colors.background,
        }}
      >
          <Slider />
          {/* <MDBCard style={{ width: "100%", }}>
            <MDBCardBody> */}
          <main style={{ flexGrow: "1", overflowX: "auto" }}>
            <div
              className="card"
              style={{ padding: "15px", width: "100%", height: "100%" }}
            >
              {/* <main style={{flexGrow: "1", width:"100%", height:"100%", flexGrow:1, flexBasis:"content", alignSelf:"bsaeline"}}>
      <div className="card"> */}
              <div className="card-body">
                <h3 className="card-title" style={{ color: "#002171" }}>
                  Operational Hydrological Drought Services using Remote Sensing
                  data
                </h3>
                <hr />
                {ReactHtmlParser(home)}
              </div>
            </div>
          </main>
        </div>
      </div>
    );
  }
}
